import Cookies from 'js-cookie';

import { getRootDomain } from './Utils';

let LocalStore = {};
let SessionStore = {};

// In some older browsers or in some incognito tabs (especially in Safari) Storage API access is disabled
// User may have disabled cookies/storage in browser settings, or may be using a browser extension for it
// In some cases, the storage may actually be full for the domain, usually it is 5-10Mb for most browsers
// In such cases we need to build a fallback method for accessing storage API without throwing any errors

const LocalStorage = {
  setItem: (key, value) => {
    try {
      window.localStorage.setItem(key, value);
    } catch (error) {
      LocalStore[key] = value;
    }
  },
  getItem: (key) => {
    try {
      return window.localStorage.getItem(key);
    } catch (error) {
      return LocalStore[key];
    }
  },
  removeItem: (key) => {
    try {
      window.localStorage.removeItem(key);
    } catch (error) {
      delete LocalStore[key];
    }
  },
  clear: () => {
    try {
      window.localStorage.clear();
    } catch (error) {
      LocalStore = {};
    }
  }
};

const SessionStorage = {
  setItem: (key, value) => {
    try {
      window.sessionStorage.setItem(key, value);
    } catch (error) {
      SessionStore[key] = value;
    }
  },
  getItem: (key) => {
    try {
      return window.sessionStorage.getItem(key);
    } catch (error) {
      return SessionStore[key];
    }
  },
  removeItem: (key) => {
    try {
      window.sessionStorage.removeItem(key);
    } catch (error) {
      delete SessionStore[key];
    }
  },
  clear: () => {
    try {
      window.sessionStorage.clear();
    } catch (error) {
      SessionStore = {};
    }
  }
};

export const putCookie = (key, val, path) => {
  const now = new Date();
  const exp = new Date(now.getFullYear() + 5, now.getMonth(), now.getDate());

  if (!path) {
    path = '/';
  }

  const options = {
    expires: exp,
    path: encodeURI(path)
  };

  Cookies.set(key, val, { ...options, domain: getRootDomain() });
  Cookies.set(key, val, { ...options, domain: window.location.host });

  if (key === '_order_id') {
    putLocalStorage(`${key}_${window.location.pathname}`, val);
  }
};

export const getCookie = (key) => {
  let val = Cookies.get(key);

  val = val === 'null' ? null : val;

  if (key === '_order_id' && !val) {
    val = getLocalStorage(`${key}_${window.location.pathname}`);
    return val;
  }

  return val;
};

export const removeCookie = (key, path) => {
  if (!path) {
    path = '/';
  }

  Cookies.remove(key, {
    path
  });
};

export const putLocalStorage = (key, value) => {
  if (
    !key ||
    typeof key !== 'string' ||
    !value ||
    typeof value === 'function' ||
    typeof value === 'symbol' ||
    typeof value === 'bigint'
  ) {
    return;
  }
  LocalStorage.setItem(key, JSON.stringify(value || ''));
};

export const getLocalStorage = (key) => {
  if (!key || typeof key !== 'string') {
    return undefined;
  }
  const value = LocalStorage.getItem(key);
  if (!value) {
    return undefined;
  }
  try {
    return JSON.parse(value);
  } catch (ex) {
    return value;
  }
};

export const deleteLocalStorage = (key) => {
  if (!key) {
    return;
  }
  LocalStorage.removeItem(key);
};

export const putSessionStorage = (key, value) => {
  if (
    !key ||
    typeof key !== 'string' ||
    !value ||
    typeof value === 'function' ||
    typeof value === 'symbol' ||
    typeof value === 'bigint'
  ) {
    return;
  }
  SessionStorage.setItem(key, JSON.stringify(value || ''));
};

export const getSessionStorage = (key) => {
  if (!key || typeof key !== 'string') {
    return undefined;
  }
  const value = SessionStorage.getItem(key);
  if (!value) {
    return undefined;
  }
  try {
    return JSON.parse(value);
  } catch (ex) {
    return value;
  }
};

export const deleteSessionStorage = (key) => {
  if (!key) {
    return;
  }
  SessionStorage.removeItem(key);
};
